import { getDisaggregatedBalancingServicesAdjustmentSummaryJsonData } from "api/dataVisualisation/disaggregatedBalancingServicesAdjustment/disaggregatedBalancingServicesAdjustment";
import useRequest, { RequestStatus } from "hooks/useRequest";
import { DisaggregatedBalancingServicesAdjustmentSummaryModel } from "models/disaggregatedBalancingServicesAdjustment/disaggregatedBalancingServicesAdjustmentSummaryModel";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { useCallback } from "react";

const useAdjustmentActionsDisbsadChartContainerData = (
  dateFilter: DateFilterModel
): {
  data: DisaggregatedBalancingServicesAdjustmentSummaryModel[] | null;
  status: RequestStatus;
  fetchData: () => void;
} => {
  const { data, status, request } = useRequest(
    getDisaggregatedBalancingServicesAdjustmentSummaryJsonData
  );

  const fetchData = useCallback(() => {
    request(dateFilter);
  }, [dateFilter, request]);

  return {
    data: data?.data ?? null,
    status,
    fetchData,
  };
};

export default useAdjustmentActionsDisbsadChartContainerData;
